import React from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { Button } from "../Button";
import { EcologiTheme } from "../theme";

const Wrapper = styled.div`
  background: #121519;
  border-bottom: 100px solid #fd8e9c;
  padding: 120px 0 400px;
  position: relative;

  &::before {
    background-image: url(/images/app/404-background.svg);
    background-repeat: repeat-x;
    background-size: 1600px;
    background-position: bottom;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    bottom: -1px;
    width: 100%;
  }
`;

const headingBase = (props: { theme: EcologiTheme }) => css`
  color: ${props.theme.colors.mushroom};
  font-size: 60px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 40px;

  @media ${props.theme.bp.mobileUp} {
    font-size: 90px;
  }
`;

export const Heading = styled.h1`
  ${headingBase};
  transform: rotate(4deg);
`;

const Subheading = styled.h1`
  ${headingBase};
  font-size: 24px;
  font-weight: 300;

  @media ${(props) => props.theme.bp.mobileUp} {
    font-size: 30px;
  }
`;

const Tree = styled.div`
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='318.12' height='496'%3E%3Cpath data-name='Shape 666 copy' d='M11 472a50.671 50.671 0 01-11 3s17.425-19.08 31-21 29.145-4.72 51-25 24.419-22.35 29-34 15.543-11.31 19-17 14.308-22.61 11-34-11.911-24.57-13-29-2-8-2-8-24.543-38.7-30-38-23.735 5.7-31-2c0 0 17.165-.22 20-9 0 0-4.248-21.81-15-32s-36.092-27.15-36-29 20.5 4.33 32 14c0 0 8.989-9.28 10-15s3.927-11.93 6-11-1.947 23.18-2 27 9.628 23.9 18 32 25.1 25.19 31 27 9.559 5.73 10-1 8.22-34.11 3-55-17.357-46.76-24-52-18.967-16.48-24-18-30.783-12.59-35-20-3.547-13.06 4-7 23.941 12.63 28 11 1.713-9.6 1-14-2.116-16.06-6-18-27.791-21.51-34-32-15.822-16.59-14-18 5 0 5 0 2.287 3.45-4-16-7.207-29.99-5-30 4.243 21.75 9 25 9.088 18.59 9 23 32.355 34.85 38 35c0 0 6.01-11.98 7-18s.078-11.38 3-17 9.52-10.04 10-14c0 0-3.184 9.61-5 15s-2.184 11.37-2 17 1.2 24.17 2 32 9.382 35.5 19 39c0 0-6.67-29.06-4-29s6.515-1.64 7 4 5.02 18.27 9 22 10 15 10 15 17.3-.61 19-7-1.25-11.26-2-17 .19-16.05 2-16 1 9 1 9l5-14s1.4 10.02 0 14a16.576 16.576 0 00-1 7s6.06 6.84 6 12 0 10 0 10 7.93-.59 8 1-1.22 3.58-8 5-10.31 5.14-11 9 .34 13.76 3 20 6.99 19.29 9 25 5.12 8.97 10 8 12.61-8.1 21-8 22.28-5.82 22-29-13.14-41.63-17-44-15.84-14.07-20-15-18.81-17.98-16-18 25.54 18.7 30 19 5.52-6.2 6-13 3.73-12.36 6-9-1.55 12.05 1 15-1.34 12.34 8 25 11.97 17.82 15 16 15.41-17.12 23-16c0 0-10.9 9.06-13 13s-7.49 16.66-7 23 5 19 5 19 22.65-1.34 27-6 10.9-21.03 16-21c0 0-6.38 9.99-6 15s-4.57 14.34 0 15 22.74 4.39 26 4-.69 7.2-11 4-22.56.22-29-1-14.9 4.74-21 6-13.77 8.49-18 9-7.77 9.7-14 13-14.53 14.97-18 17-5.74 21.83-6 29 1.8 23.98 6 37 4.05 23.73 11 16 11.73-19.11 16-21 18.32-20.91 21-21-2.97 3.82-4 9-14 24-14 24 12.7-1.96 13 2-11.43 1.75-15 5-12.04 24.37-20 36-14.29 30.01-14 39-3.02 16.68 8 26 25.6 27.94 32 29 18.34.79 29 8 18.18 8.1 16 10-41.09 1.31-51-1' fill-rule='evenodd' fill='%232f2f2f'/%3E%3Cpath d='M115 476s-51.01.5-62-1-31.981-1.73-39-1-11 1-11 1 17.425-17.08 31-19 29.145-4.72 51-25 24.419-22.35 29-34 15.543-11.31 19-17 14.31-22.61 11-34-11.911-24.57-13-29-2-8-2-8-24.543-38.7-30-38-23.735 5.7-31-2c0 0 17.165-.22 20-9 0 0-4.248-21.81-15-32s-36.092-27.15-36-29 20.5 4.33 32 14c0 0 8.989-9.28 10-15s1.927-13.93 4-13 .053 25.18 0 29 9.628 23.9 18 32 25.1 25.19 31 27 9.559 5.73 10-1 8.22-34.11 3-55-17.357-46.76-24-52-18.967-16.48-24-18-30.783-12.59-35-20-3.547-13.06 4-7 23.941 12.63 28 11 1.713-9.6 1-14-2.116-16.06-6-18-27.791-21.51-34-32-15.822-16.59-14-18 5 0 5 0 2.287 3.45-4-16S32.793.01 35 0s6.243 24.75 11 28 9.088 18.59 9 23 32.355 34.85 38 35c0 0 6.01-11.98 7-18s.078-11.38 3-17 6.52-14.04 7-18c0 0-.184 13.61-2 19s-2.184 11.37-2 17 1.2 24.17 2 32 9.382 35.5 19 39c0 0-6.67-32.06-4-32s5.515-1.64 6 4 6.02 21.27 10 25 10 15 10 15 17.3-.61 19-7-1.25-11.26-2-17-2.81-18.05-1-18 4 11 4 11l2-16s4.4 12.02 3 16a16.576 16.576 0 00-1 7s6.06 6.84 6 12 0 10 0 10 7.93-.59 8 1-1.22 3.58-8 5-10.31 5.14-11 9 .34 13.76 3 20 6.99 19.29 9 25 5.12 8.97 10 8 12.61-8.1 21-8 22.28-5.82 22-29-13.14-41.63-17-44-15.84-14.07-20-15-18.81-17.98-16-18 25.54 18.7 30 19 5.52-6.2 6-13 1.73-14.36 4-11 .45 14.05 3 17-1.34 12.34 8 25 11.97 17.82 15 16 13.41-19.12 21-18c0 0-8.9 11.06-11 15s-7.49 16.66-7 23 5 19 5 19 22.65-1.34 27-6 8.9-23.03 14-23c0 0-4.38 11.99-4 17s-4.57 14.34 0 15 22.74 4.39 26 4-.69 7.2-11 4-22.56.22-29-1-14.9 4.74-21 6-13.77 8.49-18 9-7.77 9.7-14 13-14.53 14.97-18 17-5.74 21.83-6 29 1.8 23.98 6 37 4.05 23.73 11 16 11.73-19.11 16-21 16.32-22.91 19-23-.97 5.82-2 11-14 24-14 24 12.7-1.96 13 2-11.43 1.75-15 5-12.04 24.37-20 36-14.29 30.01-14 39-3.02 16.68 8 26 25.6 27.94 32 29 18.34.79 29 8 18.18 8.1 16 10-41.09 1.31-51-1-12-3-12-3 8.19 8.39 4 8-31-1-31-1-2.23 14.14-7 14-.41-6.09-5-6-21.71-3.99-26-5-40.714 4.4-48 7-9 2-9 2 10.785-17.86 15-18z' fill-rule='evenodd'/%3E%3C/svg%3E");
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: contain;
  bottom: -50px;
  height: 400px;
  left: 50%;
  transform: translateX(-50%);
  position: absolute;
  width: 320px;

  @media ${(props) => props.theme.bp.mobileUp} {
    transform: translateX(-80%);
  }

  @media ${(props) => props.theme.bp.tabletUp} {
    transform: translateX(-140%);
  }
`;

export const NotFound = () => (
  <Wrapper>
    <div style={{ textAlign: "center", padding: "0 20px" }}>
      <Heading>Oooops!</Heading>
      <Subheading>We couldn’t find that page...</Subheading>
      <Button text="Time to go home" turquoise href="/" />
    </div>
    <Tree />
  </Wrapper>
);

export default NotFound;
